export default "__VITE_ASSET__B3569a0e__"